<template>
  <div class="stake-page">
    <div class="pt-5 pb-5">
      <Container>
        <span @click="btnBackClicked()" class="btn btn-round btn-lg btn-outline-primary pl-5 pr-5">
          {{lg('back')}}
        </span>
      </Container>
    </div>
    <Container>
      <div class="my-5">

        <!-- 信息栏 -->
        <stakeInfo :token_data="token_data" :token_balance_info="token_balance_info"/>

        <!-- 4个按钮 -->
        <div v-if="!status_show_stake_pad && !status_show_unstake_pad" class="mt-4 card px-4 py-3">
          <div class="btn-set">

            <span @click="toggleStakePad()" class="btn btn-round btn-lg btn-primary">
              {{lg('stake_tokens')}}
            </span>

            <span @click="toggleUnstakePad()" class="btn btn-round btn-lg btn-outline-primary">
              {{lg('unstake_tokens')}}
            </span>

            <span @click="actionClaim()" class="btn btn-round btn-lg btn-outline-primary">
              {{lg('claim_rewards')}}
            </span>

            <span @click="actionExit()" class="btn btn-round btn-lg btn-outline-primary">
              {{lg('exit_claim_and_unstake')}}
            </span>

          </div>
        </div>

        <!-- Stake 操作面板 -->
        <div v-if="status_show_stake_pad" class="mt-4 card px-4 py-3">
          <h4>
            {{lg('stake_tokens')}}
          </h4>

          <div class="input-group my-3">
            <input v-model="input_num_stake" type="text" class="form-control form-control-lg">
            <div class="input-group-append">
              <span class="input-group-text">
                <span class="btn btn-outline-primary btn-sm" @click="input_num_stake = token_balance_info.num_balance.toString()">
                  Max
                </span>
              </span>
            </div>
            <div class="input-group-append">
              <span class="input-group-text">{{token_data.token_symbol}}</span>
            </div>
          </div>

          <div>

            <div class="btn-set">

              <span @click="toggleStakePad()" class="btn btn-lg btn-outline-primary">
                {{lg('cancel')}}
              </span>

              <span v-if="!status_is_approve" @click="actionApprove()" class="btn btn-lg btn-primary">
                {{lg('approve')}}
              </span>
              <span v-if="status_is_approve" @click="actionStake()" class="btn btn-lg btn-primary">
                {{lg('stake')}}
              </span>

            </div>

          </div>
        </div>

        <!-- Unstake 操作面板 -->
        <div v-if="status_show_unstake_pad" class="mt-4 card px-4 py-3">
          <h4>
            {{lg('unstake_tokens')}}
          </h4>

          <div class="input-group my-3">
            <input v-model="input_num_unstake" type="text" class="form-control form-control-lg">
            <div class="input-group-append">
              <span class="input-group-text">
                <span class="btn btn-outline-primary btn-sm" @click="input_num_unstake = token_balance_info.num_staked.toString()">
                  Max
                </span>
              </span>
            </div>
            <div class="input-group-append">
              <span class="input-group-text">{{token_data.token_symbol}}</span>
            </div>
          </div>

          <div>

            <div class="btn-set">

              <span @click="toggleUnstakePad()" class="btn btn-lg btn-outline-primary">
                {{lg('cancel')}}
              </span>

              <span @click="actionUnstake()" class="btn btn-lg btn-primary">
                {{lg('unstake')}}
              </span>

            </div>

          </div>
        </div>

      </div>
    </Container>

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import stakeInfo from './stake_info.vue'
// import ethers from 'ethers'

// import data_main_list_stake from '@/data/main_list_stake.js'
// import data_main_list_pool from '@/data/main_list_pool.js'
import data_main_list_active from '@/data/main_list_stake.js'
import data_main_list_inactive from '@/data/main_list_stake_inactive.js'
let data_main_list = [].concat(data_main_list_active,data_main_list_inactive) 
import Container from '@/components/Container.vue'

export default {
  name: 'stakePage',
  components: {
    stakeInfo,
    Container,
  },
  props: [],
  data() {
    return {

      // 
      status_show_stake_pad: false,
      input_num_stake: '',
      
      // 
      status_show_unstake_pad: false,
      input_num_unstake: '',

      // token_balance_info
      token_balance_info: {
        num_balance: '',
        num_staked: '',
        num_reward: '',
      },

      // 
      status_is_approve: false,

    }
  },
  computed: {
    token_data(){
      let v = this
      let temp = {}
      let target_list = data_main_list
      for(let item of target_list){
        if ((item.id || '').toLowerCase() === (v.$route.params.id || '').toLowerCase()){
          temp = item
        }
      }
      return JSON.parse(JSON.stringify(temp))
    },
  },
  watch: {

  },
  methods: {
    ...mapActions([
      'stakeStakeToken',
      'unstakeStakeToken',
      'claimReward',
      'exitStake',

      'hasApproveStakeToken',
      'approveStakeToken',
    ]),

    btnBackClicked(){
      let v = this
      v.$router.push(
        {
          name: 'farm',
          query: {
            tab: data_main_list_inactive.find( item => v.token_data.id === item.id) ? 'inactive' : ''
          },
        }
      )
    },

    toggleStakePad(){
      let v = this
      v.input_num_stake = isNaN(v.token_balance_info.num_balance) ? '': v.token_balance_info.num_balance
      v.status_show_stake_pad = !v.status_show_stake_pad
    },

    toggleUnstakePad(){
      let v = this
      v.input_num_unstake = isNaN(v.token_balance_info.num_staked)? '': v.token_balance_info.num_staked
      v.status_show_unstake_pad = !v.status_show_unstake_pad
    },

    // approve
    async actionApprove(){
      let v = this

      let token_address = v.token_data.token_address
      let reward_address = v.token_data.reward_address

      await v.approveStakeToken({
        stakeTokenAddress: token_address,
        stakeRewardAddress: reward_address,
        callback: function(){
          v.status_is_approve = true
        },
      })
    },

    // stake
    async actionStake(){
      let v = this
      let num = v.input_num_stake
      let token_address = v.token_data.token_address
      let reward_address = v.token_data.reward_address

      v.stakeStakeToken({
        id: v.token_data.id,
        stakeTokenAddress: token_address,
        stakeRewardAddress: reward_address,
        num: num,
      })
    },

    // unstake
    async actionUnstake(){
      let v = this
      let num = v.input_num_unstake
      let reward_address = v.token_data.reward_address
      let token_address = v.token_data.token_address

      v.unstakeStakeToken({
        id: v.token_data.id,
        stakeTokenAddress: token_address,
        stakeRewardAddress: reward_address,
        num: num,
      })
    },

    // actionClaim
    async actionClaim(){
      let v = this
      // let num = v.input_num_unstake
      let reward_address = v.token_data.reward_address

      v.claimReward(reward_address)
    },

    // actionExit
    async actionExit(){
      let v = this
      let reward_address = v.token_data.reward_address
      v.exitStake(reward_address)
    },

    // 
    async checkApprove(){
      let v = this
      
      let token_address = v.token_data.token_address
      let reward_address = v.token_data.reward_address
      let my_address = v.$store.state.web3.account

      let mark = await v.hasApproveStakeToken({
        id: v.token_data.id,
        stakeTokenAddress: token_address,
        stakeRewardAddress: reward_address,
        address: my_address,
      })
      v.status_is_approve = mark
    },
  },
  created() {
    this.checkApprove()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .stake-page{
    .btn-set{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .btn{
        min-width: 48%;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    // 样式覆盖
    .input-group{
      input{
        border-right: none !important;
      }
      .input-group-text{
        background-color: transparent !important;
        font-size: 18px;
        

        &:last-child{
          border-left: none !important;
        }
      }
    }
  }

  @media(max-width: 789px){
    .stake-page{
      
      // 上提页面
      .boxed{
        margin-top: 0 !important;
      }

      .btn-set{
        .btn{
          width: 100%;
        }
      }
    }
  }
</style>